import { ResourceService } from 'src/app/shared/resource-service';
import { environment } from 'src/environments/environment';

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Site } from './site';
import { SiteSerializer } from './site.serializer';

@Injectable()
export class SiteService extends ResourceService<Site> {
  constructor(
    private http: HttpClient,
    private siteSerializer: SiteSerializer
  ) {
    super(http, `${environment.backendApiUrl}/sites`, siteSerializer)
  }
}
